import * as axios from "axios"
import { analyticsPushFunc } from "../../../../widgetsUtils"
import { CommentFormType } from "./interfaces"
import { getTranslation } from "./translations"

export interface AddCommentFormRenderProps {
    lang: string
    articleId: string
    formType: CommentFormType
    name: string
    email: string
    location: string
    title: string
    comment: string
    isSent: boolean
    isPreviewModeOn: boolean
    showAlert: boolean
    alertBeforeClosing: () => void
    closeAlert: () => void
    handleCommentSend: () => void
    handleCloseCommentForm: () => void
    resetFormData: () => void
    onInputChanged: any
    isAddCommentFormVisible: boolean
    isFirstComment?: boolean
    togglePreviewMode?: () => void
    shouldTitleBeHidden?: boolean
    isPopUpOpened?: boolean
    onClosePopUp?: () => void
    soldierName?: string
    profileImageSrc?: string
    roof?: string
    isNewDesign?: boolean
    nameError?: string
    commentError?: string
    siteName?: string
}

export type AddCommentFormRender = (
    props: AddCommentFormRenderProps
) => React.ReactElement<any>

interface AddCommentFormWrapperProps {
    render: AddCommentFormRender
    articleId: string
    parentTalkbackId?: number
    formType: CommentFormType
    lang: string
    isAddCommentFormVisible: boolean
    handleCloseCommentForm: () => void
    isFirstComment?: boolean
    postId?: string
    shouldTitleBeHidden?: boolean
    isNewDesign?: boolean
    siteName?: string

}

interface AddCommentFormWrapperState {
    name: string
    email: string
    location: string
    title: string
    comment: string
    isSent: boolean
    isPreviewModeOn: boolean
    showAlert: boolean
    nameError: string
    commentError: string
}

export class AddCommentFormWrapper extends React.Component<AddCommentFormWrapperProps, AddCommentFormWrapperState> {
    constructor(props) {
        super(props)
        this.state = {
            name: "",
            email: "",
            location: "",
            title: "",
            comment: "",
            isSent: false,
            isPreviewModeOn: false,
            showAlert: false,
            nameError: "",
            commentError: "",
        }
    }

    private resetFormData = () => {
        this.setState({
            name: "",
            email: "",
            location: "",
            title: "",
            comment: "",
            isSent: false,
            isPreviewModeOn: false,
            nameError: "",
            commentError: "",
        })
    }

    private onInputChanged = (e, inputName: string, shouldInsertToTitle?: boolean) => {
        const inputValue = e.target.value as string
        const nextState: Partial<AddCommentFormWrapperState> = { [inputName]: inputValue } as any
        if (inputName === "name") {
            nextState.nameError = ""
        }
        if (inputName === "comment") {
            nextState.commentError = ""
        }
        this.setState(nextState as AddCommentFormWrapperState)
        if (shouldInsertToTitle) {
            const title = inputValue.length > 50 ? inputValue.substring(0, 47) + "..." : inputValue;
            this.setState({ ["title"]: title })
        }
    }

    private handleCommentSend = () => {
        const { articleId, parentTalkbackId, formType, lang, postId, shouldTitleBeHidden, isNewDesign } = this.props
        const { title, name, email, location, comment } = this.state

        if (isNewDesign) {
            const nameError = name.trim().length === 0 ? getTranslation(lang, "You Must Enter Name") : ""
            const commentError = comment.trim().length === 0 ? getTranslation(lang, "You Must Enter Text") : ""
            if (nameError || commentError) {
                analyticsPushFunc("Fail", "Send Comment", title)
                this.setState({ nameError, commentError })
                return
            }
        }

        if (title.length > 0) {
            const postData = {
                talkback_title: title,
                talkback_content: comment,
                author_name: name,
                author_email: email,
                author_location: location,
                article_id: articleId,
                talkbackParentData: formType === "REPLY" ? parentTalkbackId : "",
                talkback_source: null,
                postId: postId
            }
            analyticsPushFunc("Success", "Send Comment", title)
            axios.post(`/iphone/json/api/talkbacks/add`, postData)
            this.setState({ isSent: true, nameError: "", commentError: "" })
        }
        else {
            analyticsPushFunc("Fail", "Send Comment", title)
            if (isNewDesign) {
                this.setState({ commentError: getTranslation(lang, "You Must Enter Text") })
            } else {
                alert(shouldTitleBeHidden ? getTranslation(lang, "You Must Enter Text") : getTranslation(lang, "You Must Enter Title"))
            }
        }
    }

    private togglePreviewMode = () => {
        const { isPreviewModeOn, title } = this.state
        const { shouldTitleBeHidden, lang } = this.props

        if (title.length === 0) {
            alert(shouldTitleBeHidden ? getTranslation(lang, "You Must Enter Text") : getTranslation(lang, "You Must Enter Title"))
        } else {
            this.setState({ isPreviewModeOn: !isPreviewModeOn })
        }
    }

    private alertBeforeClosing = () => {
        const { title, comment } = this.state
        const { lang, handleCloseCommentForm, shouldTitleBeHidden } = this.props
        if (lang === "he" && (comment !== "" || title !== "") && !shouldTitleBeHidden) {
            this.setState({ showAlert: true })
        }
        else handleCloseCommentForm();
    }

    private closeAlert = () => {
        this.setState({ showAlert: false })
    }

    render() {
        const { isAddCommentFormVisible, lang, articleId, handleCloseCommentForm, isFirstComment, isNewDesign } = this.props
        const { isSent, isPreviewModeOn, title, name, email, location, comment, showAlert, nameError, commentError } = this.state

        return (
            <div className="mainFormWrapper">
                {this.props.render(
                    {
                        lang,
                        articleId,
                        formType: "NEW",
                        handleCloseCommentForm,
                        name,
                        email,
                        location,
                        title,
                        comment,
                        isSent,
                        isPreviewModeOn,
                        showAlert,
                        isAddCommentFormVisible,
                        alertBeforeClosing: this.alertBeforeClosing,
                        closeAlert: this.closeAlert,
                        togglePreviewMode: this.togglePreviewMode,
                        handleCommentSend: this.handleCommentSend,
                        resetFormData: this.resetFormData,
                        onInputChanged: this.onInputChanged,
                        isFirstComment,
                        isNewDesign,
                        nameError,
                        commentError,
                    }
                )}
            </div>)
    }
}